export class IEngineRenderContext {

}